// libs
import React, { memo } from 'react';

// components
import ResponsibleTags from './ResponsibleTags';
import ResponsibleTagsV2 from './Mobile';

// types
import { ResponsibleTagsProps } from './types';

function WithConfig({ className, widget, responsibleTagsEnabled, isMobile }: ResponsibleTagsProps) {
  // do not render anything if both the responsible tags are disabled via config
  if (!responsibleTagsEnabled) {
    return null;
  }

  // for desktop return existing responsible tags
  if (!isMobile) {
    return (
      <ResponsibleTags
        className={className}
        widget={widget}
        responsibleTagsEnabled={responsibleTagsEnabled}
        isMobile={isMobile}
      />
    );
  }

  // return new responsible tags component by default
  return <ResponsibleTagsV2 className={className} widget={widget} />;
}

export default memo(WithConfig);
